<template>
  <div class="home">
    <!--
    <HelloWorld msg="Welcome to Your Vue.js App"/>
    -->
    <dashboard></dashboard>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld,
    Dashboard: () => import(/* webpackChunkName: "dashboard" */ '@/components/Dashboard.vue')
  }
}
</script>
